import React from 'react';
import {
  ListViewIcon, Wrapper, GridViewIcon, CustomButton
} from './styled';

export const GridViewButton = ({ showGridView, onToggleView }) => {
  // The button will only render if showGridView is false
  return !showGridView && (
    <Wrapper>
      <CustomButton
        startIcon={ <GridViewIcon /> }
        onClick={ onToggleView } // Call the onToggleView function passed as a prop
      >
        Grid View
      </CustomButton>
    </Wrapper>
  );
};

export const ListViewButton = ({ showGridView, onToggleView }) => {
  // The button will only render if showGridView is true
  return showGridView && (
    <Wrapper>
      <CustomButton
        startIcon={ <ListViewIcon /> }
        onClick={ onToggleView } // Call the onToggleView function passed as a prop
      >
        List View
      </CustomButton>
    </Wrapper>
  );
};
